import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { areParamsInitialize, initialState, reducer } from './reducers';
import { getParamsFromQueryString } from '../helpers';

const StoreContext = createContext(initialState);

const StoreProvider = ({ children }) => {
  const initialStateMergedWithSearchParams = {
    ...initialState,
    ...getParamsFromQueryString(),
  };

  // if params are in query string, we want to be able to reset the form
  initialStateMergedWithSearchParams.resetIsStale
    = areParamsInitialize(initialStateMergedWithSearchParams);

  const [state, dispatch] = useReducer(reducer, initialStateMergedWithSearchParams);

  function logDispatch(...arg) {
    if (__DEVELOPMENT__) {
      console.log('StoreContext dispatch() ', ...arg, state);
    }

    dispatch(...arg);
  }

  return (
    <StoreContext.Provider value={{ state, dispatch: logDispatch }}>
      {children}
    </StoreContext.Provider>
  );
};

StoreProvider.propTypes = {
  children: PropTypes.node,
};

export { StoreContext, StoreProvider };
